import { makeStyles } from '../styles';
export const useButtonStyles = makeStyles(({ palette, spacing }) => ({
    button: {
        position: 'relative',
        margin: ({ margin }) => margin && spacing(1, 0),
        padding: '4px 20px',
        width: 'auto',
        fontSize: spacing(2),
        border: 0,
        outline: 'none',
        borderRadius: 3,
        cursor: 'pointer',
        transition: 'opacity 100ms ease-in',
        textDecoration: 'none',
    },
    bold: {
        fontWeight: 'bold',
    },
    contents: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'opacity 100ms ease-in',
    },
    /**
     * THEMES
     * */
    primary: {
        backgroundColor: palette.secondary.main,
        color: palette.text.light,
        minWidth: 88,
        border: `1px solid ${palette.secondary.main}`,
        '&:hover': {
            backgroundColor: palette.secondary.dark,
            borderColor: palette.secondary.dark,
            '&:disabled': {
                backgroundColor: palette.secondary.main,
                borderColor: palette.secondary.main,
            },
        },
    },
    secondary: {
        color: palette.secondary.main,
        background: palette.background.default,
        border: `1px solid ${palette.secondary.main}`,
        '&:hover': {
            color: palette.secondary.dark,
            borderColor: palette.secondary.dark,
        },
    },
    secondaryNegative: {
        color: palette.error.main,
        background: palette.background.default,
        border: `1px solid ${palette.error.main}`,
    },
    negative: {
        background: palette.error.main,
        color: palette.error.contrastText,
        '&:hover': {
            backgroundColor: palette.error.dark,
            borderColor: palette.error.dark,
        },
    },
    edit: {
        backgroundColor: palette.grey.main,
        color: palette.text.light,
        padding: '10px 20px',
        margin: '10px 0px',
        minWidth: 130,
    },
    link: {
        background: 'transparent',
        color: palette.secondary.main,
        cursor: 'pointer',
        border: 'none',
        borderRadius: 0,
        padding: 0,
        '&:hover': {
            color: palette.secondary.dark,
            textDecoration: 'underline',
        },
        '&:disabled': {
            color: palette.primary.main,
            opacity: '50%',
            textDecoration: 'underline',
        },
    },
    back: {
        border: 'none',
        color: palette.grey.offBlack,
        background: 'url("../../../../assets/images/chevron-left.svg") no-repeat left',
        backgroundSize: '6px 13px',
        paddingLeft: 10,
        backgroundPosition: '0 11px',
        position: 'relative',
        top: '-10px',
    },
    warning: {
        backgroundColor: `${palette.warning.main} !important`,
        color: palette.text.light,
    },
    option: {
        display: 'block',
        color: palette.secondary.main,
        backgroundColor: 'transparent',
    },
    disabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
    /**
     * SIZING
     * */
    wide: {
        width: '100%',
    },
    /**
     * LOADING
     * */
    buttonLoading: {
        opacity: 0.5,
        pointerEvents: 'none',
        padding: '6px 20px',
        minWidth: '100px',
        '&:after': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            pointerEvents: 'auto',
            cursor: 'not-allowed',
        },
    },
    medium: {},
    small: {
        fontSize: 14,
        fontWeight: 400,
    },
    default: {},
    success: {
        color: `${palette.success.main}!important`,
    },
    error: {
        color: `${palette.error.main}!important`,
    },
}));
//# sourceMappingURL=button.styles.js.map